export default __webpack_public_path__ + "static/media/young-business-man-pumps-chest-first-aid-emergency-cpr.45aeb335.jpg";